import type { ChangeEvent } from 'react';

import { getSeparators, parseNumber } from 'src/app/utils/number';

export const isNumberOrNullOrDecimalSeparator = (
  event: ChangeEvent<HTMLInputElement>,
): boolean => {
  // We expect the value to be the new value of the field
  const value = event.target.value;

  // We expect the data to be the character that has been inputted (or
  // characters when a number has been copy and pasted).
  const input = (event.nativeEvent as InputEvent).data;

  // When the field being changed has the text "1,000", the caret is at the end
  // of the text, and the user presses the 0 key, then `value` would be
  // "1,0000", and `input` would be "0". (Elsewhere, the improper separator
  // position would be corrected. 1,0000 would become 10,000 before being shown
  // to the user.)
  // A null value for input could be caused by pressing backspace or delete.

  // We return false when the input is not valid, so that the calling code can
  // skip updating state or triggering validation.

  if (input === null && isNaN(parseNumber(value)) && value !== '') {
    return false;
  }

  return (
    input === null || /[0-9]/.test(input) || input === getSeparators().decimal
  );
};
